var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68 15.72V2.28A1.28 1.28 0 012.96 1h4.723a1.28 1.28 0 011.28.973L9.36 3.56h7.68a1.28 1.28 0 011.28 1.28v10.88A1.28 1.28 0 0117.04 17H2.96a1.28 1.28 0 01-1.28-1.28z",
    stroke: "currentColor",
    strokeWidth: 1.714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgContract;